/** @jsx jsx */

import { MouseEvent, memo, useCallback } from 'react';

import { jsx } from '@emotion/core';

type ClickPropagationBarrierProps = {
  className?: string;
  children?: React.ReactNode;
};

const ClickPropagationBarrier = memo((props: ClickPropagationBarrierProps) => {
  const { children, className } = props;
  const stopPropagation = useCallback((event: MouseEvent) => {
    event.stopPropagation();
  }, []);
  return (
    <div className={className} onClick={stopPropagation} role="presentation">
      {children}
    </div>
  );
});

export default ClickPropagationBarrier;
